import React from 'react';
import { Box, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useStepNavigationAmountStyles from '../MUI/StepNavigationAmount/makeStyles';
import StepNavigationButtons from '../MUI/StepNavigationButtons';
import LoadingAnimation from '../Loaders/LoadingAnimation/LoadingAnimation';
import Form from './Form';
import ScrollToTopPage from '../ScrollToTopPage';
import useDeviceResize from '../../hooks/useDeviceResize';
import useRegisterValidationFields from '../../hooks/useRegisterValidationFields';
import { EFES_CONTENT_WIDTH, FULL_WIDTH } from '../../constants/uiConstants';

const OncoCareCalculator = ({
  handleOpenMobileSummary,
  buyButtonHandler,
  showNavigationButtons,
  totalPriceAfterDiscount,
  formProps,
  setAge,
  age,
  showAgeInput,
  setWithChildren,
  withChildren,
  showWithChildrenCheckbox,
  riskAmount,
  setRiskAmount,
  riskAmounts,
  isFetchingRiskAmounts,
  prices,
  paymentFrequencies,
  setPaymentFrequency,
  paymentFrequency,
  isFetchingPrice,
}) => {
  const { t } = useTranslation();
  const stepNavigationAmountClasses = useStepNavigationAmountStyles();
  const isDeviceLgSize = useDeviceResize('extraLgSize');
  const { register } = formProps;

  useRegisterValidationFields([
    'age',
  ], register);

  if (isFetchingRiskAmounts) {
    return <LoadingAnimation />;
  }

  return (
    <Box>
      <ScrollToTopPage />
      <Form
        formProps={formProps}
        setAge={setAge}
        age={age}
        showAgeInput={showAgeInput}
        setWithChildren={setWithChildren}
        withChildren={withChildren}
        showWithChildrenCheckbox={showWithChildrenCheckbox}
        riskAmount={riskAmount}
        setRiskAmount={setRiskAmount}
        paymentFrequencies={paymentFrequencies}
        riskAmounts={riskAmounts}
        prices={prices}
        setPaymentFrequency={setPaymentFrequency}
        paymentFrequency={paymentFrequency}
      />
      {showNavigationButtons && isDeviceLgSize && (
        <Grid
          container
          className={classNames({
            [stepNavigationAmountClasses.mobileNavigation]: isDeviceLgSize,
          })}
          spacing={isDeviceLgSize ? 4 : 0}
        >
          <Grid item style={{ width: isDeviceLgSize ? FULL_WIDTH : EFES_CONTENT_WIDTH }}>
            <Box>
              <StepNavigationButtons
                btnText={t('buyOnline')}
                amount={totalPriceAfterDiscount}
                handleOpenMobileSummary={handleOpenMobileSummary}
                buttonHandler={buyButtonHandler}
                isFetchingPrice={isFetchingPrice}
              />
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

OncoCareCalculator.propTypes = {
  showAgeInput: PropTypes.bool,
  showWithChildrenCheckbox: PropTypes.bool,
  handleOpenMobileSummary: PropTypes.func,
  buyButtonHandler: PropTypes.func,
  showNavigationButtons: PropTypes.bool,
  totalPriceAfterDiscount: PropTypes.number,
  formProps: PropTypes.shape({
    register: PropTypes.func,
  }).isRequired,
  setAge: PropTypes.func.isRequired,
  age: PropTypes.number,
  setWithChildren: PropTypes.func.isRequired,
  withChildren: PropTypes.bool,
  riskAmount: PropTypes.arrayOf(PropTypes.number).isRequired,
  setRiskAmount: PropTypes.func.isRequired,
  riskAmounts: PropTypes.arrayOf(PropTypes.string).isRequired,
  isFetchingRiskAmounts: PropTypes.bool.isRequired,
  prices: PropTypes.shape({}),
  paymentFrequencies: PropTypes.shape({}),
  setPaymentFrequency: PropTypes.func.isRequired,
  paymentFrequency: PropTypes.shape({}).isRequired,
  isFetchingPrice: PropTypes.bool,
};

OncoCareCalculator.defaultProps = {
  showAgeInput: true,
  showWithChildrenCheckbox: true,
  handleOpenMobileSummary: () => { },
  buyButtonHandler: () => { },
  showNavigationButtons: true,
  totalPriceAfterDiscount: 0,
  prices: {},
  age: null,
  withChildren: false,
  paymentFrequencies: {},
  isFetchingPrice: false,
};

export default OncoCareCalculator;
